import { CatalogApi } from '@backstage/catalog-client';
import { useEffect, useState } from 'react';

export const useTemplateCategories = (catalogApi: CatalogApi) => {
  const [categories, setCategories] = useState<string[]>([]);

  useEffect(() => {
    const fetchCategories = async () => {
      const { items } = await catalogApi.getEntities({
        filter: { kind: 'Template' },
        fields: ['spec.type'],
      });

      const categoryArray = [
        ...new Set(
          items
            .map(e => e.spec?.type)
            .filter((type): type is string => Boolean(type)),
        ),
      ].sort((a, b) => a.localeCompare(b));

      setCategories(categoryArray);
    };

    fetchCategories();
  }, [catalogApi]);

  return categories;
};
